export const fieldsMapTipoMaterial = {
    ocorrenciaNo: { name: 'tipoMaterialId', type: 'number' },
    V_28015: { name: 'tipoMaterialId', type: 'number' },
    // V_30412: { name: 'materialId', type: 'number' },
    V_34708: { name: 'name', type: 'string' }, // material
    V_28017: { name: 'habilitado', type: 'boolean' },
    // V_28016: { name: 'titulo', type: 'boolean' },
};
